import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { getSubtypeHeader } from '../../../utils/subTypeHeader';

export default function ProfessionalForm({ shopType, formState, setFormState }) {
  const subtype = shopType;
  const headerText = getSubtypeHeader(subtype);

  const bookingMethods = [
    { label: 'Online Form', value: 'Online Form' },
    { label: 'Email', value: 'Email' },
    { label: 'Phone Call', value: 'Phone Call' },
    { label: 'In-person', value: 'In-person' }
  ];

  return (
    <div className="form-section">
      <h3 className="section-title">{headerText}</h3>

      {/* Shared fields */}
      <div className="field">
        <div className="flex align-items-center">
          <Checkbox
            inputId={`licensed_${subtype}`}
            checked={formState[`licensed_${subtype}`] || false}
            onChange={(e) => setFormState(`licensed_${subtype}`, e.checked)}
          />
          <label htmlFor={`licensed_${subtype}`} className="ml-2">Licensed Provider</label>
        </div>
      </div>

      <div className="field">
        <label>Consultation Booking</label>
        <Dropdown
          value={formState[`consultationBooking_${subtype}`]}
          options={bookingMethods}
          onChange={(e) => setFormState(`consultationBooking_${subtype}`, e.value)}
          placeholder="Select Booking Method"
        />
      </div>

      <div className="field">
        <div className="flex align-items-center">
          <Checkbox
            inputId={`confidentiality_${subtype}`}
            checked={formState[`confidentiality_${subtype}`] || false}
            onChange={(e) => setFormState(`confidentiality_${subtype}`, e.checked)}
          />
          <label htmlFor={`confidentiality_${subtype}`} className="ml-2">Confidentiality Agreement</label>
        </div>
      </div>

      {/* PS_legal */}
      {subtype === 'PS_legal' && (
        <>
          <div className="field">
            <label>Practice Areas</label>
            <InputText
              value={formState[`practiceAreas_${subtype}`] || ''}
              onChange={(e) => setFormState(`practiceAreas_${subtype}`, e.target.value)}
              placeholder="e.g. Family Law, Corporate Law"
            />
          </div>
          <div className="field">
            <div className="flex align-items-center">
              <Checkbox
                inputId={`courtRepresentation_${subtype}`}
                checked={formState[`courtRepresentation_${subtype}`] || false}
                onChange={(e) => setFormState(`courtRepresentation_${subtype}`, e.checked)}
              />
              <label htmlFor={`courtRepresentation_${subtype}`} className="ml-2">Offers Court Representation</label>
            </div>
          </div>
        </>
      )}

      {/* PS_accounting */}
      {subtype === 'PS_accounting' && (
        <>
          <div className="field">
            <label>Accounting Services</label>
            <InputText
              value={formState[`accountingServices_${subtype}`] || ''}
              onChange={(e) => setFormState(`accountingServices_${subtype}`, e.target.value)}
              placeholder="e.g. Bookkeeping, Tax Filing"
            />
          </div>
          <div className="field">
            <div className="flex align-items-center">
              <Checkbox
                inputId={`certifiedCPA_${subtype}`}
                checked={formState[`certifiedCPA_${subtype}`] || false}
                onChange={(e) => setFormState(`certifiedCPA_${subtype}`, e.checked)}
              />
              <label htmlFor={`certifiedCPA_${subtype}`} className="ml-2">Certified CPA</label>
            </div>
          </div>
        </>
      )}

      {/* PS_engineering */}
      {subtype === 'PS_engineering' && (
        <>
          <div className="field">
            <label>Engineering Specialization</label>
            <InputText
              value={formState[`engineeringField_${subtype}`] || ''}
              onChange={(e) => setFormState(`engineeringField_${subtype}`, e.target.value)}
              placeholder="e.g. Civil, Electrical, Mechanical"
            />
          </div>
          <div className="field">
            <div className="flex align-items-center">
              <Checkbox
                inputId={`siteVisit_${subtype}`}
                checked={formState[`siteVisit_${subtype}`] || false}
                onChange={(e) => setFormState(`siteVisit_${subtype}`, e.checked)}
              />
              <label htmlFor={`siteVisit_${subtype}`} className="ml-2">Offers Site Visits</label>
            </div>
          </div>
        </>
      )}

      {/* PS_consulting */}
      {subtype === 'PS_consulting' && (
        <>
          <div className="field">
            <label>Consulting Areas</label>
            <InputText
              value={formState[`consultingFocus_${subtype}`] || ''}
              onChange={(e) => setFormState(`consultingFocus_${subtype}`, e.target.value)}
              placeholder="e.g. Business Strategy, HR, IT"
            />
          </div>
          <div className="field">
            <div className="flex align-items-center">
              <Checkbox
                inputId={`onlineConsultation_${subtype}`}
                checked={formState[`onlineConsultation_${subtype}`] || false}
                onChange={(e) => setFormState(`onlineConsultation_${subtype}`, e.checked)}
              />
              <label htmlFor={`onlineConsultation_${subtype}`} className="ml-2">Offers Online Consultation</label>
            </div>
          </div>
        </>
      )}

      {subtype === 'PS_hr' && (
        <>
          <div className="field">
            <label>HR Services</label>
            <InputText
              value={formState[`hrServices_${subtype}`] || ''}
              onChange={(e) => setFormState(`hrServices_${subtype}`, e.target.value)}
              placeholder="e.g. Recruitment, Payroll, Labor Consulting"
            />
          </div>
          <div className="field">
            <label>Target Business Size</label>
            <InputText
              value={formState[`hrBusinessSize_${subtype}`] || ''}
              onChange={(e) => setFormState(`hrBusinessSize_${subtype}`, e.target.value)}
              placeholder="e.g. SMEs, Large Corporations"
            />
          </div>
        </>
      )}
    </div>
  );
}
